import React from 'react';
import gql from 'graphql-tag';
import { graphql } from '@apollo/react-hoc';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import Container from '../../components/Container';
import EventDetails from './event-details';
import { SimpleLoadingComponent } from '../../utils/apollo';

import './styles.css';

export class EventFairDetails extends React.PureComponent {
  static propTypes = {
    node: PropTypes.object,
    viewer: PropTypes.object,
  };

  render() {
    const { node } = this.props;

    const eventDetails = {
      contact: (get(node, 'highSchool.repVisitsAccount.collegeFairsPrimaryContact') ||
        get(node, 'highSchool.repVisitsAccount.primaryContact')),
      phone: (get(node, 'highSchool.repVisitsAccount.collegeFairsPrimaryContactPhone') ||
        get(node, 'highSchool.repVisitsAccount.primaryContactPhone') || 'N/A'),
      cost: get(node, 'cost'),
      expectedStudents: get(node, 'numberOfExpectedStudents'),
      instructions: get(node, 'webInstructions'),
      title: get(node, 'name'),
    };
    return (
      <Container styleName="event-details">
        <EventDetails type="fair" highSchool={get(node, 'highSchool')} eventDetails={eventDetails} />
      </Container>
    );
  }
}

const query = gql`
  query EventFairAgendaDetails($id: ID!) {
    node(id: $id) {
      id
      ... on CollegeFair {
        cost
        numberOfExpectedStudents
        name
        rsvpDeadline
        webInstructions
        notes
        highSchool {
          id
          name
          address {
            field_hs_elna_address_line1
            field_hs_elna_state_latest
            field_hs_elna_city
            field_hs_eln_zip
          }
          repVisitsAccount {
            id
            primaryContactPhone
            primaryContact {
              id
              name
              field_job_position
              field_contact_work
              field_profile_picture_file_url
            }
            collegeFairsPrimaryContact {
              id
              name
              field_job_position
              field_contact_work
              field_profile_picture_file_url
            }
            collegeFairsPrimaryContactPhone
          }
        }
      }
    }
  }
`;

const graphqlData = graphql(query, {
  options: ({ id }) => ({
    variables: {
      id,
    },
  }),
});

export default SimpleLoadingComponent(graphqlData)(EventFairDetails);
